/**
 * Common view settings keys.
 *
 * @enum {string}
 * @readonly
 * @see net/disy/cadenza/workbook/service/WorkbookSettingsConstants.java
 */
export const VIEW_SETTINGS_CONSTANTS = {
  // eslint-disable-next-line id-denylist
  NAME: 'common.view.name',
  BACKGROUND_COLOR: 'common.view.background.color',
  BACKGROUND_COLOR_OPACITY: 'common.view.background.color.opacity',
  NAME_MAX_LENGTH: 255,
  DESCRIPTION: 'common.view.description',
  DESCRIPTION_SHOW_ATTRIBUTES: 'common.view.description.show.attributes',
  DESCRIPTION_SHOW_DESCRIPTION: 'common.view.description.show.description',
  MEDIA_REPOSITORY_NAME: 'common.view.media.repositoryName',
  MEDIA_CONTENT_IDENTIFIER: 'common.view.media.contentIdentifier',
  MEDIA_SIGNATURE: 'common.view.media.signature'
};
